(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sun-global"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var h = document.querySelector('.sf-header');
      if (h) {
        var wrap = h.querySelector('.header__wrapper');
        if (wrap) {
          var hasHero = !!document.querySelector('.sun-hero');
          if (hasHero) { document.documentElement.classList.add('sun-has-hero'); }
          var threshold = hasHero ? 80 : 40;
          var update = function () {
            var y = window.scrollY;
            if (y > threshold) { wrap.classList.add('sun-pinned'); } else { wrap.classList.remove('sun-pinned'); }
            if (hasHero) {
              if (y > threshold) { wrap.classList.remove('transparent-on-top'); } else { wrap.classList.add('transparent-on-top'); }
            } else {
              wrap.classList.remove('transparent-on-top');
            }
          };
          update();
          if (!h.dataset.sunHdr) { h.dataset.sunHdr = '1'; window.addEventListener('scroll', update, { passive: true }); }
        }
      }
      var f = document.querySelector('.sf-footer');
      if (f && !f.querySelector('.sun-footer-wordmark')) {
        var w = document.createElement('div');
        w.className = 'sun-footer-wordmark';
        w.textContent = 'SUNCILLO';
        f.insertBefore(w, f.firstChild);
      }
      sunBucks();
      sunAboutMenu();
    }

    // Add a dropdown under the desktop "ABOUT" nav item, using the theme's
    // OWN native submenu markup/classes so the theme's CSS styles and reveals
    // it identically to the SHOP/COLLECTIONS dropdowns (no custom styling).
    function sunAboutMenu() {
      var links = document.querySelectorAll('.sf-header__desktop a.sf__parent-item, .sf-header__desktop .sf-menu-bar a');
      var items = [
        ['Contact', '/pages/contact'],
        ['Stocklists', '/pages/stocklists'],
        ['Shipping', '/pages/shipping'],
        ['Sizing Chart', '/pages/sizing-chart'],
        ['Terms & Conditions', '/pages/terms-conditions']
      ];
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        if (a.textContent.trim().toUpperCase().indexOf('ABOUT') !== 0) continue;
        var li = a.closest('li');
        if (!li || li.dataset.sunAbout) continue;
        li.dataset.sunAbout = '1';
        // Match a native dropdown parent so the theme's hover/positioning applies
        li.classList.add('sf-menu-item', 'sf__menu-item-level1', 'sf-menu-item-parent', 'sf-menu-item--no-mega');
        a.classList.add('sf__sub-menu-link1');
        // Native caret (theme flips it on hover via .sf-menu-item:hover .sf-menu__arrow)
        if (!a.querySelector('.sf-menu__arrow')) {
          var span = document.createElement('span');
          span.className = 'ml-2 sf-menu__arrow';
          span.innerHTML = '<svg class="w-2 h-2" fill="currentColor" viewBox="0 0 448 512"><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"/></svg>';
          a.appendChild(span);
        }
        // Build the exact native submenu structure
        var lis = '';
        for (var j = 0; j < items.length; j++) {
          lis += '<li class="list-none sf__menu-item-level2 w-full leading-9">'
               + '<a href="' + items[j][1] + '" class="sf__sub-menu-link2 whitespace-normal block sf-sub-menu__link">'
               + items[j][0] + '</a></li>';
        }
        var wrap = document.createElement('div');
        wrap.className = 'sf-menu__submenu sf-menu__desktop-sub-menu pointer-events-none absolute z-50 inset-x-0 sf-menu__dropdown min-w-max bg-white';
        wrap.setAttribute('style', '--total-columns: 1');
        wrap.innerHTML = '<div class="sf-menu__inner"><div class="mx-auto"><div class="sf-menu-submenu__content flex p-4"><ul class="sf-menu-submenu__items flex flex-col w-full">' + lis + '</ul></div></div></div>';
        li.appendChild(wrap);
      }
    }

    // Move the Bucks currency widget into the header nav, and fix its
    // dropdown so it closes when a currency is picked.
    function sunBucks() {
      var box = document.querySelector('.buckscc-floating-box');
      if (box) {
        var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        var header = document.querySelector(isDesktop ? '.sf-header__desktop' : '.sf-header__mobile');
        if (header) {
          var anchor = header.querySelector('.sf-search-form, .sf-search-form--full, [data-search]');
          box.classList.add('sun-cc-in-nav');
          if (anchor && anchor.parentNode) {
            if (anchor.previousElementSibling !== box) { anchor.parentNode.insertBefore(box, anchor); }
          } else if (box.parentNode !== header) {
            header.appendChild(box);
          }
        }
      }
      // Close the dropdown the moment a currency is selected (the app
      // forgets to drop its open `.active` state, so the list stays open).
      if (!document.documentElement.dataset.sunCcClose) {
        document.documentElement.dataset.sunCcClose = '1';
        document.addEventListener('click', function (e) {
          if (!e.target.closest('.buckscc-select-options')) return;
          setTimeout(function () {
            var list = document.querySelectorAll('.buckscc-select-styled.active');
            for (var i = 0; i < list.length; i++) {
              list[i].classList.add('bucks__drop-down_close');
              list[i].classList.remove('active');
            }
          }, 80);
        }, true);
      }
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
    document.addEventListener('shopify:section:load', init);

    // The Bucks widget is injected asynchronously after load — keep trying to
    // relocate it into the nav until it appears, then watch for re-insertions.
    var sunTries = 0;
    var sunPoll = setInterval(function () {
      sunTries++;
      var box = document.querySelector('.buckscc-floating-box');
      if (box) { sunBucks(); }
      if ((box && box.classList.contains('sun-cc-in-nav')) || sunTries > 40) { clearInterval(sunPoll); }
    }, 250);
    if (window.MutationObserver) {
      new MutationObserver(function () { sunBucks(); }).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('resize', function () { sunBucks(); }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
